import Components from "../components";

class ChannelImport extends Components.Base {
  initialize() {
    this.selectCount = 0;
  }

  bind() {
    this.$el.find(".channel-select").on("change", this.channelToggled.bind(this));
    this.$submit = this.$el.find("button[type='submit']")
  }

  channelToggled(event) {
    if(event.target.checked) {
      this.selectCount += 1;
    } else {
      this.selectCount -= 1;
    }

    if(this.selectCount > 0) {
      const name = this.selectCount > 1 ? "integrations" : "integration"
      this.$submit.text(`Import ${this.selectCount} ${name}`)
      this.$submit.prop('disabled', false)
    } else {
      this.$submit.text(`Import`)
      this.$submit.prop('disabled', true)
    }
  }
}

Components.collection.register({
  selector: '.c-channel-import',
  klass: ChannelImport,
});
